module.exports = __webpack_public_path__ + "a3b90b3ba2dddd4d961c9985588159c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/img/pencil-icon.png
// module id = 26
// module chunks = 0